import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';

interface Props extends PropsWithChildren {
  title: string;
  description?: string;
}

const PageContainer: React.FC<Props> = ({ title, description, children }) => (
  <div>
    <Helmet>
      <title>{title}</title>
      {!!description && <meta name="description" content={description} />}
      <link rel="shortcut icon" href="/build/images/favicon.png" />
    </Helmet>
    {children}
  </div>
);

export default PageContainer;
